export default __webpack_public_path__ + "static/media/cover.ad22fade.jpg";